import axios from "axios";
import { HttpClient, RequestParams } from "../../utils/api/http-client";
import { ACCESS_TOKEN } from "../../utils/helpers/constants";

class MediaService<SecurityDataType = unknown> {
  http: HttpClient<SecurityDataType>;

  constructor(http: HttpClient<SecurityDataType>) {
    this.http = http;
  }

  getMedia = (id: number, params?: RequestParams) =>
    this.http.request<any>({
      path: `/media/${id}`,
      method: "GET",
      ...params,
    });

  updateMedia = (id: number, without_background: boolean, is_notification?: boolean, params?: RequestParams) =>
    this.http.request<any>({
      path: `/media/${id}`,
      method: "PUT",
      body: { without_background },
      ...params,
    });
  uploadMedia = async (formData: FormData) => {
    const response = await axios.post(`${process.env.REACT_APP_BASE_API_URL}/media`, formData, {
      headers: {
        "Content-Type": "multipart/form-data",
        "Authorization": `Bearer ${localStorage.getItem(ACCESS_TOKEN) ??
          sessionStorage.getItem(ACCESS_TOKEN)
          }`,
      },
    });
    return response.data;
  };

}

export default MediaService;
